import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import hrTranslation from './locales/hr/translation.json';
import enTranslation from './locales/en/translation.json';
import itTranslation from './locales/it/translation.json';
import deTranslation from './locales/de/translation.json';

const resources = {
  hr: {
    translation: hrTranslation
  },
  en: {
    translation: enTranslation
  },
  it: {
    translation: itTranslation
  },
  de: {
    translation: deTranslation
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'hr', // Default jezik je Hrvatski
    lng: 'hr', // Početni jezik
    debug: false,
    
    interpolation: {
      escapeValue: false // React već automatski escapuje
    },

    detection: {
      // Detektira jezik iz localStorage > navigator language
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    }
  });

export default i18n;
